import LazyLoad from "vanilla-lazyload";
import lazyLoad from "./components/lazyLoad";
import ScrollToTop from "./components/scrollToTop";
import MobileBurgerMenu from "./components/mobileBurgerMenu";
import coverTable from "./components/coverTable";
import loadGame from "./components/loadGame";
import Faq from "./components/faq";
import toc from "./components/toc";

document.addEventListener('DOMContentLoaded', function () {

    lazyLoad();

    let myLazyLoad = new LazyLoad();

    ScrollToTop();

    MobileBurgerMenu();

    // adaptive table class
    coverTable();

    // iframe on click
    loadGame();

    Faq();

    toc();
});



